export default {
  title: 'Push-ilmoitukset',
  description: 'Lähetä kohdennettuja push-ilmoituksia asiakkaillesi',
  buttons: {
    new_campaign: 'Uusi kampanja',
  },
  error_messages: {
    no_mobile_app: {
      title: 'Mobiilisovellus ei ole vielä julkaistu',
      description: 'Odota, että mobiilisovellus julkaistaan, ennen kuin voit lähettää push-ilmoituksia',
    },
  },
};
